import * as React from "react";
import { Context } from "./_context";
export const RefreshIcon = ({ size = 24, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[24] = /* @__PURE__ */ React.createElement("svg", { width: "1.5rem", height: "1.5rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M17.707 4.793a1 1 0 0 1 0 1.414l-3.5 3.5-1.414-1.414L14.586 6.5H11.5A6.5 6.5 0 1 0 18 13h2a8.5 8.5 0 1 1-8.5-8.5h3.086l-1.793-1.793 1.414-1.414 3.5 3.5Z", fill: "currentColor" }));
  return iconset[size];
};
RefreshIcon.iconId = "qJpvqR";
